import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import { SHARED_VARIABLES_REFERENCE_OBJECT } from './SharedVariablesReferenceObject';
/**
 * Default breakpoints.
 */

export var BREAKPOINTS_BASE = {
  SM: 500,
  MD: 768,
  XL: 1284
};
export var pxToEm = function pxToEm(px) {
  return "".concat(px / 16, "em");
};
export var pxToRem = function pxToRem(px) {
  return "".concat(px / 10, "rem");
};
/**
 * @param breakpoints Defaults to 500, 768, 1284. Pass in themed breakpoints object to get breakpoints in em.
 * @returns breakpoints in em
 */

export var breakpointsToEm = function breakpointsToEm() {
  var breakpoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : BREAKPOINTS_BASE;
  return {
    SM: pxToEm(breakpoints.SM),
    MD: pxToEm(breakpoints.MD),
    XL: pxToEm(breakpoints.XL)
  };
};
export var BREAKPOINTS_BASE_EM = breakpointsToEm();
/**
 * BREAKPOINTS_BASE_EM_MIN_WIDTH_MEDIA_QUERY is consumed by useMediaQuery as default
 * @param breakpointsEm Defaults to 500/16 em, 768/16 em, and 1284/16 em. {@link pxToEm}
 */

export var breakpointsToEmMinWidthMediaQuery = function breakpointsToEmMinWidthMediaQuery() {
  var breakpointsEm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : BREAKPOINTS_BASE_EM;
  return Object.keys(breakpointsEm).reduce(function (breakpoints, key) {
    return _extends({}, breakpoints, _defineProperty({}, key, "print, screen and (min-width: ".concat(breakpointsEm[key], ")")));
  }, {});
};
export var BREAKPOINTS_BASE_EM_MIN_WIDTH_MEDIA_QUERY = breakpointsToEmMinWidthMediaQuery();
export var DEFAULT_BREAKPOINTS_ASC_BASE = [BREAKPOINTS_BASE_EM.MD, BREAKPOINTS_BASE_EM.XL];
/**
 * These are mapped to the actual theme variables in ./SharedVariables.ts {@link baseVariables}
 * Onboarding themes use the base values above.
 */

export var BREAKPOINTS = SHARED_VARIABLES_REFERENCE_OBJECT.BREAKPOINTS;
export var BREAKPOINTS_EM = SHARED_VARIABLES_REFERENCE_OBJECT.BREAKPOINTS_EM;
export var BREAKPOINTS_EM_MIN_WIDTH_MEDIA_QUERY = SHARED_VARIABLES_REFERENCE_OBJECT.BREAKPOINTS_EM_MIN_WIDTH_MEDIA_QUERY;
export var DEFAULT_BREAKPOINTS_ASC = SHARED_VARIABLES_REFERENCE_OBJECT.DEFAULT_BREAKPOINTS_ASC;